import { IPrijavnica } from './../model/index';
import axios, { AxiosResponse, AxiosPromise } from 'axios';
import { IEnotaZrss } from '@/model';


const baseAddress = process.env.VUE_APP_BASE_API_URL;


export function GetEnoteZrss(): AxiosPromise<IEnotaZrss[]> {
    return axios.get(`${baseAddress}/EnoteZrss`);
}

export function PostGetToken(username: string, password: string): AxiosPromise<string> {
    const bodyFormData = new FormData();

    bodyFormData.append('username', username);
    bodyFormData.append('password', password);

    return axios.post(`${baseAddress}/auth`, {username, password});
}


export function PostPrijavnica(prijavnica: any): AxiosPromise<IEnotaZrss[]> {
    return axios.post(`${baseAddress}/prijavnice`, JSON.stringify(prijavnica));
}

export function GetPrijavniceList(token: string): AxiosPromise<IPrijavnica[]> {
    return axios.get(`${baseAddress}/prijavnice`, { headers: { authorization: 'Bearer ' + token } });
}

export function DownloadExcel(token: string): AxiosPromise<Blob> {
    return axios.get(`${baseAddress}/prijavnice/excel`, {  responseType: 'blob',   headers: { authorization: 'Bearer ' + token, } });
}
